import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import SectionTitle from 'components/Presentation/SectionTitle';
import SectionProgress from 'containers/Progress/Section';
import TeacherSectionProgress from 'containers/Progress/TeacherSection';
import React, { Component } from 'react';
import { Spinner } from 'UI';
import { translate } from '@haldor/ui';
import { connect } from 'react-redux';
import { Icon } from '@haldor/ui';
import User from '_class/User';

var Assessments = /*#__PURE__*/function (_Component) {
  _inherits(Assessments, _Component);

  var _super = _createSuper(Assessments);

  function Assessments() {
    _classCallCheck(this, Assessments);

    return _super.apply(this, arguments);
  }

  _createClass(Assessments, [{
    key: "render",
    value: function render() {
      var user = new User(this.props.currentUser);

      if (this.props.group == null) {
        return /*#__PURE__*/React.createElement("div", {
          className: "section teams-assessment"
        }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
          name: "People"
        }), this.props.translate('assessments-header-overview')), /*#__PURE__*/React.createElement(Spinner, {
          center: true
        }));
      }

      return /*#__PURE__*/React.createElement("div", {
        className: "section teams-assessment"
      }, /*#__PURE__*/React.createElement(SectionTitle, null, /*#__PURE__*/React.createElement(Icon, {
        name: "People"
      }), this.props.translate('assessments-header-overview')), user.isStudent() ? /*#__PURE__*/React.createElement(SectionProgress, {
        groupId: this.props.groupId,
        userId: this.props.currentUser.id
      }) : /*#__PURE__*/React.createElement("div", null, this.props.group.students != null && this.props.group.students.length > 0 ? /*#__PURE__*/React.createElement(TeacherSectionProgress, {
        groupId: this.props.groupId
      }) : /*#__PURE__*/React.createElement("div", null, this.props.translate('Students appear in the list below once they access the plans. If a student isn\'t listed, ask them to access a plan to appear in the list.'))));
    }
  }]);

  return Assessments;
}(Component);

function mapStateToProps(state) {
  return {
    translate: translate(state.Languages.translations),
    currentUser: state.user.currentUser,
    group: state.sections.activeSection
  };
}

export default connect(mapStateToProps)(Assessments);